import { h2 } from './styles';
export default {
    h2,
};
